<template>
<div style="background-color: #fdd7c2">

  <first></first>
  <second></second>
  <third></third>
  <fourth></fourth>
  <fifth></fifth>
</div>
</template>

<script>
import first from "@/components/first";
import second from "@/components/second";
import third from "@/components/third";
import fourth from "@/components/fourth";
import fifth from "@/components/fifth";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "home",
  components:{
    first,second,third,fourth,fifth
  },
  data(){
    return{
    }
  },
  mounted() {
    let _this = this;
    $(window).scroll(function(obj){
      // _this.scrollanimate($(".liukoushui"),'home_4_liukoushui_move')
      // _this.scrollanimate($(".liukoushui_png"),'home_4_liukoushui_move')
      _this.scrollanimate($(".shoppingcart"),'h5-shoppingcart-move')
      // _this.scrollanimate($(".qiezi"),'h4-qiezi-move')
      // _this.scrollanimate($(".qiezi_png"),'h4-qiezi-move')
    })
  },
  methods:{
    scrollanimate(obj,animationname){
      const w = document.documentElement.clientWidth;
      const h = document.documentElement.clientHeight;
      let windowHeight,scrollDistance,objDistance;
      if(w>h){
        windowHeight=$(window).width();
        scrollDistance=$(window).scrollLeft();
        objDistance = obj.offset().left;
      }else{
        windowHeight=$(window).height();
        scrollDistance=$(window).scrollTop();
        objDistance = obj.offset().top;
      }
      if (objDistance >= scrollDistance && objDistance < (windowHeight+scrollDistance)){
        // console.log('大于要出现了')
        obj.addClass(animationname)
      }else {
        // console.log('小于')
        // obj.removeClass(animationname)
      }
    }
  }
}
</script>

<style scoped>

</style>
